import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import {
  ContactCtaSection,
  PageHero,
  ProductsSection,
} from "../components/JalRoSections";

const ProductsPage = () => (
  <JalRoLayout>
    <PageHero
      title="RO Products"
      text="Domestic RO, RO + UV + UF systems, alkaline RO, mineral RO, and commercial RO plants."
    />
    <ProductsSection />
    <ContactCtaSection />
  </JalRoLayout>
);

export default ProductsPage;
